import { useMemo } from 'react'
import { addTz } from 'utils/timeZoneUtil'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { DashboardWidget } from 'features/widget/types'
import { TimelineWidget } from '../../../../types'

const retrieveMetrics = (widgetData: DashboardWidget<AnnotatedMetricResult>) =>
  widgetData?.data?.[0]?.results?.[0]?.data?.metrics || []

const useXCoordinates = (widgetSetting: TimelineWidget) => {
  const pageConfigUser = usePageConfigUser()
  const { widgetId, timeUnit } = widgetSetting
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId!)

  const originalXCoordinates = useMemo(
    () =>
      retrieveMetrics(widgetData).filter(
        (currentMetric) => currentMetric.timeUnit === timeUnit
      )?.[0]?.columns || [],
    [widgetData, timeUnit]
  )
  // For highcharts, we need to convert the x coordinates to the localized time.
  const localizedXCoordinates = useMemo(
    () => originalXCoordinates.map((x) => addTz(x!, pageConfigUser.timeZone)),
    [originalXCoordinates, pageConfigUser.timeZone]
  )

  return { localizedXCoordinates, originalXCoordinates }
}

export default useXCoordinates
